"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cascader = exports.transformData = void 0;
var tslib_1 = require("tslib");
/* eslint-disable react/destructuring-assignment */
var react_1 = tslib_1.__importDefault(require("react"));
var CascaderSingle_1 = require("./CascaderSingle");
var CascaderMultiple_1 = require("./CascaderMultiple");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var deep_copy_1 = require("../_util/deep-copy");
function isCascaderData(data) {
    return !Array.isArray(data) && typeof data === "object";
}
function transformData(data) {
    var result = isCascaderData(data)
        ? data
        : { title: "", options: data };
    if (result.options) {
        result.options = result.options.map(function (option) {
            if (option.child || option.children) {
                option.child = transformData(option.children || option.child);
            }
            // 兼容菜单模式动态加载
            if (!option.child && option.isLeaf === false) {
                option.child = { title: "" };
            }
            return option;
        });
    }
    return result;
}
exports.transformData = transformData;
exports.Cascader = forward_ref_with_statics_1.forwardRefWithStatics(function Cascader(props, ref) {
    if (props.multiple) {
        return (react_1.default.createElement(CascaderMultiple_1.CascaderMultiple, tslib_1.__assign({ ref: ref }, props, { data: transformData(deep_copy_1.deepCopy(props.data)), multiple: true })));
    }
    return (react_1.default.createElement(CascaderSingle_1.CascaderSingle, tslib_1.__assign({ ref: ref }, props, { data: transformData(deep_copy_1.deepCopy(props.data)) })));
}, {
    defaultLabelAlign: "middle",
});
exports.Cascader.displayName = "Cascader";
//# sourceMappingURL=Cascader.js.map